<template>
        <div class="row">
         <div class="col-12">
             <form id="form-edit-compliance" v-on:submit.prevent="addComplieanceAffair">
                <div class="form-group">
                    <ejs-textbox name="title" v-model="dataForm.titulo" placeholder="Titulo:" data-msg-containerid="formTitleError"></ejs-textbox>
                    <div id="formTitleError"></div>
                </div>
                <div class="form-group">
                    <ejs-dropdownlist v-model="dataForm.relevancia" :dataSource="relevancia" placeholder="Relevancia:"></ejs-dropdownlist>
                </div>
                <div class="form-group">
                    <ejs-dropdownlist v-model="dataForm.periodicidad" :dataSource="periodicidad" placeholder="Periodicidad:" v-on:change="resetDate()"></ejs-dropdownlist>
                </div>
                <div class="form-group" v-show="dataForm.periodicidad == 'Periodico'">
                    <ejs-dropdownlist 
                        v-model="dataForm.periodo" 
                        :dataSource="listPeriodicidad" 
                        placeholder="Periodo:"
                        :showClearButton="true"
                        :showDropDownIcon="true"
                        :fields="{ text: 'label', value: 'value' }"
                    />
                </div>
                <div class="form-group">
                    <ejs-textbox name="description" :multiline="true" v-model="dataForm.descripcion" placeholder="Descripcion:" data-msg-containerid="formDescriptionError"></ejs-textbox>
                    <div id="formDescriptionError"></div>
                </div>
                <div class="row" v-if="dataForm.periodicidad != 'Permanente'">
                    <div class="col-6" v-for="(d, k) in dataForm.fecha" :key="k">
                        <div class="form-group" >
                            <ejs-datepicker 
                                v-model="dataForm.fecha[k]" 
                                start='Decade' 
                                :placeholder="'Fecha cumplimiento ' +(k + 1)+ ':'" 
                                required="required"
                                :format="'yyyy-MM-dd'"
                            />
                            <button type="button" class="btn btn-sm btn-danger" v-if="dataForm.periodicidad == 'Periodico' && dataForm.fecha.length > 1" v-on:click="deleteDate(k)">X</button>
                        </div>
                    </div>
                </div>
                <div class="form-group" v-if="dataForm.periodicidad == 'Periodico'">
                    <button type="button" class="btn btn-sm e-btn e-info" style="text-transform: none !important;" v-on:click="addDate()">Añadir fecha</button>
                </div>
                <div class="form-group" v-show="['Unica Vez', 'Periodico'].includes(dataForm.periodicidad) && !showReportingAuthorityName">
                    <ejs-dropdownlist 
                        id="reporting-authority"
                        name="reportingAuthority"
                        placeholder="Ante quién se ejecuta:"
                        v-model="dataForm.reportingAuthority" 
                        :allowFiltering="true" 
                        :enableVirtualization="true"
                        :dataSource="reportingAuthorities" 
                        :fields="{ text: 'name', value: 'id' }"
                        :filterBarPlaceholder="'Buscar autoridad...'"
                        :noRecordsTemplate="'No se encontraron autoridades'"
                        :filterType="'Contains'"
                        title="Selecciona una autoridad"
                        data-msg-containerid="reportingAuthorityMsg"
                    />
                    <div id="reportingAuthorityMsg"></div>
                    <div class="text-muted" style="font-size: 0.8em;">
                        Si no se encuentra la autoridad, haz clic <span class="text-primary" style="cursor: pointer;" v-on:click="showReportingAuthorityName = true">aquí</span> para crearla.
                    </div>
                </div>
                <div class="form-group" v-show="showReportingAuthorityName">
                    <div class="text-muted" style="font-size: 0.8em;">
                        Para volver a la lista haz clic <span class="text-primary" style="cursor: pointer;" v-on:click="showReportingAuthorityName = false">aquí</span>.
                    </div>
                    <ejs-textbox 
                        name="Nombre de la autoridad" 
                        v-model="dataForm.reportingAuthorityName" 
                        placeholder="Nombre de la autoridad:" 
                        data-msg-containerid="reportingAuthorityName"
                        :showClearButton="true"
                    />
                    <div id="reportingAuthorityName"></div>
                    <ejs-checkbox 
                        label="Marcar como pública (visible para todos los tenants)" 
                        name="status"
                        v-model="dataForm.isPublicReportingAuthority"
                        :checked="dataForm.isPublicReportingAuthority"
                    />
                </div>
                <ejs-progressbutton type='submit' cssClass="e-primary" ref="progressBtnFormUsers" :disabled="disabledButton">Guardar</ejs-progressbutton>
            </form>
         </div>
    </div>
</template>
<script>
import axios from 'axios';

export default {
    name: 'add-compliance',
    props: ['data'],
    data() {
        return {
            dataForm: {
                id_asunto: this.data.id,
                titulo: '',
                relevancia: 'Baja',
                periodicidad: 'Permanente',
                descripcion: '',
                fecha: [''],
                reportingAuthority: null,
                isPublicReportingAuthority: false,
                currentTenant: localStorage.getItem('TID') || null,
            },
            listPeriodicidad: [],
            fieldPeriodicidad: {text: "periodo", value: 'periodo' },
            disabledButton: false,
            spinSettings: { position: 'Right', width: 20 },
            relevancia: ['Baja', 'Media', 'Alta'],
            periodicidad: ['Permanente', 'Unica Vez', 'Periodico'],
            reportingAuthorities: [],
            formObject: '',
            optionsForms: {
                rules: {
                    'title': {	
                        required: [true, "* Campo título requerido."],
                    },
                    'description': {	
                        required: [true, "* Campo descripción requerido."],
                    },
                }
            },
            showReportingAuthorityName: false
        }
    },
    mounted: function () {
        this.formObject = new FormValidator('#form-edit-compliance', this.optionsForms);
        this.getListPeriodicidad();
        this.getReportingAuthorities();
    },
    methods: {
        addComplieanceAffair: function () {
            let formStatus = this.formObject.validate();
            if (formStatus) {
                this.disabledButton = true;
                this.dataForm.currentTenant = localStorage.getItem('TID') || null;
                axios.post('/auth/regulatoryAffairs/addCompliance',{
                    data: this.dataForm
                }).then((response) => {
                    this.disabledButton = false;
                    Vue.prototype.$eventHub.$emit('showToastNotification', response.data);
                    Vue.prototype.$eventHub.$emit("toggleSidebarClick","Asociar Norma","add-rule-compliance",{id : response.data.cumplimiento_id, normas: []},"mw-100");
                    Vue.prototype.$eventHub.$emit('onGetCompliance');
                }).catch(error => {
                    this.disabledButton = false;
                    Vue.prototype.$eventHub.$emit('showToastNotification', {
                        status: 'error',
                        message: error.response.data.message || 'Error al procesar la solicitud.'
                    });
                });
            }
        },
        getListPeriodicidad : function (){
            axios.post('/auth/compliance/getListPeriodicidad',)
                .then((response) => {
                    this.listPeriodicidad = response.data;
                });
        },
        addDate: function () {
            this.dataForm.fecha.push('');
        },
        resetDate: function (){
            this.dataForm.fecha = [''];
        },
        deleteDate: function (key){
            this.dataForm.fecha.splice(key, 1);
        },
        getReportingAuthorities: function () {
            const TID = localStorage.getItem('TID') || null;
            axios.get('/reporting-authorities', { params: { TID } })
                .then((response) => {
                    this.reportingAuthorities = response.data;
                });
        }
    }
}
</script>
<style>
    .col-6 > .form-group > span{
        width: 80% !important;
    }
</style>